import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChecklist"><Path d="M11.5 16.5H20.5M11.5 7.5H20.5M3.5 8L5.5 9.5L8.5 5M3.5 17L5.5 18.5L8.5 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChecklist;
